(() => {
  const config = document.querySelector('[data-santa-login-tracking]');
  if (!config || window.Shopify?.designMode) return;

  const PIXEL_ID = '1642603806774287';
  const GOOGLE_ADS_ID = 'AW-18154541104';
  const GOOGLE_ADS_CONVERSION_ID = 'AW-18154541104/r4f4COKIovkcELCg4dBD';
  const STORAGE_KEY = 'santa:login-registration';
  const PARAM = 'santa_login_return';
  const UNTRACKED_RETURN = 'untracked';
  const MAX_AGE = 15 * 60 * 1000;
  const authenticated = config.dataset.authenticated === 'true';
  const current = new URL(window.location.href);
  const returnId = current.searchParams.get(PARAM);
  let completed = false;
  let leaving = false;

  const marketingAllowed = () =>
    window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;

  const clearPending = () => {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch { /* Fail closed. */ }
  };

  const goToDestination = () => {
    if (leaving) return;
    leaving = true;
    const destination = authenticated && config.dataset.noOrders === 'true'
      ? config.dataset.welcomeUrl : config.dataset.accountUrl;
    window.location.replace(destination || config.dataset.accountUrl);
  };

  const sendGoogleConversion = () => {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
      const src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
      if (!document.querySelector(`script[src="${src}"]`)) {
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        document.head.appendChild(script);
      }
      window.gtag('js', new Date());
    }
    window.gtag('config', GOOGLE_ADS_ID, { send_page_view: false });
    window.gtag('event', 'conversion', {
      send_to: GOOGLE_ADS_CONVERSION_ID,
      value: 1.0,
      currency: 'USD'
    });
  };

  // Only a matching, recent attempt in this tab can produce a conversion.
  // Visiting while already signed in is not itself a registration event.
  const finishLogin = () => {
    if (!returnId || completed) return;
    completed = true;
    let attempt;
    if (returnId !== UNTRACKED_RETURN) {
      try { attempt = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)); } catch { /* No event. */ }
    }
    const age = Date.now() - attempt?.startedAt;
    const valid = authenticated && attempt?.id === returnId && age >= 0 && age <= MAX_AGE;
    clearPending();
    current.searchParams.delete(PARAM);
    window.history.replaceState(null, '', current.href);

    // Navigation uses the authenticated Shopify order count, independently of tracking consent.
    if (!valid || !marketingAllowed()) {
      goToDestination();
      return;
    }

    // Both tags share the same eligibility and bounded time before navigation.
    window.setTimeout(goToDestination, 2000);
    try {
      sendGoogleConversion();
    } catch { /* Google failures must not prevent Meta tracking or navigation. */ }
    let sent = false;
    const send = () => {
      if (sent || leaving || !marketingAllowed()) return;
      sent = true;
      window.fbq('set', 'autoConfig', false, PIXEL_ID);
      const pixels = window.fbq.getState?.()?.pixels || [];
      if (!pixels.some(pixel => String(pixel.id) === PIXEL_ID)) window.fbq('init', PIXEL_ID);
      window.fbq('trackSingle', PIXEL_ID, 'CompleteRegistration', {
        content_name: 'Shopify customer login',
        status: true
      });
      // fbq has no delivery acknowledgement; receipt is verified in Meta Test Events.
    };

    if (typeof window.fbq?.callMethod === 'function') {
      send();
      return;
    }
    if (typeof window.fbq !== 'function') {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      window._fbq = window._fbq || fbq;
    }
    let script = document.querySelector('script[src="https://connect.facebook.net/en_US/fbevents.js"]');
    if (script) {
      script.addEventListener('load', send, { once: true });
    } else {
      script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.addEventListener('load', send, { once: true });
      document.head.appendChild(script);
    }
  };

  document.addEventListener('click', event => {
    const link = event.target?.closest?.('[data-santa-login]');
    if (!link || authenticated || event.defaultPrevented) return;
    // Preserve modified clicks, new tabs, and the original link as the no-JS fallback.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;
    let id = UNTRACKED_RETURN;
    clearPending();
    if (marketingAllowed()) {
      try {
        const attemptId = window.crypto.randomUUID();
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ id: attemptId, startedAt: Date.now() }));
        id = attemptId;
      } catch { /* Navigation still works without a tracking attempt. */ }
    }
    try {
      const destination = new URL(config.dataset.rootUrl, current.origin);
      destination.searchParams.set(PARAM, id);
      const login = new URL('/customer_authentication/login', current.origin);
      login.searchParams.set('return_to', destination.pathname + destination.search);
      event.preventDefault();
      window.location.assign(login.href);
    } catch { /* Invalid route configuration: keep the original login link. */ }
  });

  // Do not hold up account navigation if the privacy API cannot initialize.
  const fallback = returnId ? window.setTimeout(() => {
    if (completed) return;
    completed = true;
    clearPending();
    goToDestination();
  }, 2000) : undefined;
  const privacyReady = () => {
    window.clearTimeout(fallback);
    finishLogin();
  };
  if (typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function') {
    privacyReady();
  } else {
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], privacyReady);
  }
})();
